import { TableCell } from "@mui/material";
import { Check, Close, Create, Delete } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import CustomFabButton from "../../components/Button/CustomFabButton";

export default function SparePartNoteActionButtons(props) {
    const { t } = useTranslation("translation");
    return (
        <TableCell align="center" id="tb_actions">
            {props.editable && props.editableRow === props.row.id ? (
                <>
                    {/* Confirm */}
                    <CustomFabButton
                        id="tb_UpdateAdd"
                        disabled={props.addDisabled}
                        title={t("Confirm")}
                        onClick={() => props.updateAddHandler(props.row)}
                        icon={<Check />}
                        color="primary"
                        aria-label="confirm"
                        style={{ marginRight: 5 }}
                    />

                    {/* Cancel */}
                    <CustomFabButton
                        id="tb_DisableEdit"
                        title={t("Cancel")}
                        onClick={props.disableEditHandler}
                        icon={<Close />}
                        color="secondary"
                        aria-label="cancel"
                        style={{ marginRight: 5 }}
                    />
                </>
            ) : (
                <>
                    {/* Edit */}
                    <CustomFabButton
                        id="tb_EnableEdit"
                        title={t("Edit")}
                        onClick={() => props.enableEditHandler(props.row)}
                        icon={<Create />}
                        color="primary"
                        aria-label="edit"
                        style={{ marginRight: 5 }}
                    />

                    {/* Delete */}
                    <CustomFabButton
                        id="tb_Delete"
                        title={t("Delete")}
                        onClick={() => props.deleteButtonHandler(props.row)}
                        icon={<Delete />}
                        color="secondary"
                        aria-label="delete"
                        style={{ marginRight: 5 }}
                    />
                </>
            )}
        </TableCell>
    );
}
